import styled from 'styled-components';
import { Layout, Typography, Button } from 'antd';
import { FONT_SIZE, media, BREAKPOINTS } from '../../../styles/themes/constants';
import { Link } from 'react-router-dom';

// Navbar height - adjust based on your DefaultNavbar
const NAVBAR_HEIGHT = '72px';

// ==================== Layout Containers ====================

// Main page wrapper - adds top padding for navbar
export const PageWrapper = styled.div`
  min-height: 100vh;
  padding-top: ${NAVBAR_HEIGHT};
  background: #fafafa;
`;

// Desktop container with sidebar and content
export const DesktopContainer = styled.div`
  display: flex;
  min-height: calc(100vh - ${NAVBAR_HEIGHT});
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 32px;
  
  @media (min-width: ${BREAKPOINTS.xxl}px) {
    padding: 0 64px;
  }
`;

// Sidebar column for desktop
export const SidebarColumn = styled.div`
  width: 260px;
  min-width: 260px;
  padding: 32px 24px 32px 0;
  border-right: 1px solid #f0f0f0;
  background: transparent;
  position: sticky;
  top: ${NAVBAR_HEIGHT};
  height: calc(100vh - ${NAVBAR_HEIGHT});
  overflow-y: auto;
  
  @media (max-width: ${BREAKPOINTS.lg}px) {
    width: 220px;
    min-width: 220px;
  }
`;

// Content column for desktop
export const ContentColumn = styled.div`
  flex: 1;
  padding: 32px 0 32px 32px;
  min-width: 0;
  
  @media (min-width: ${BREAKPOINTS.xxl}px) {
    padding: 32px 0 32px 48px;
  }
`;

// Content card with shadow
export const ContentCard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 32px 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  min-height: calc(100vh - ${NAVBAR_HEIGHT} - 150px);
  
  @media (max-width: ${BREAKPOINTS.lg}px) {
    padding: 24px 32px;
  }
`;

// Mobile container
export const MobileContainer = styled.div`
  padding: 16px;
  min-height: calc(100vh - ${NAVBAR_HEIGHT});
`;

// ==================== Legacy styles ====================

export const LayoutMaster = styled(Layout)`
  height: 100vh;
`;

export const LayoutMain = styled(Layout)`
  @media only screen and ${media.md} {
    margin-left: 80px;
  }

  @media only screen and ${media.xl} {
    margin-left: unset;
  }
`;

export const Paragraph = styled(Typography.Paragraph)`
  &.ant-typography {
    margin-bottom: 10px;
    font-size: ${FONT_SIZE.xs};
  }
`;

export const TextLink = styled(Link)`
  &.ant-typography {
    margin-bottom: 0;
    padding-left: 20px;
    padding-bottom: 20px;
    font-size: ${FONT_SIZE.xxs};
  }
`;

// ==================== Mobile specific styles ====================

export const MobileMenuButton = styled.button`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #1677ff 0%, #0958d9 100%);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(22, 119, 255, 0.4);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateX(-50%) translateY(-2px);
    box-shadow: 0 6px 24px rgba(22, 119, 255, 0.5);
  }
  
  &:active {
    transform: translateX(-50%) translateY(0);
  }
  
  @media (min-width: ${BREAKPOINTS.xl}px) {
    display: none;
  }
`;

export const DrawerTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #1a1a2e;
`;

export const MobileSiderWrapper = styled.div`
  padding: 8px 0;
  
  .ant-tree {
    font-size: 15px;
    
    .ant-tree-node-content-wrapper {
      padding: 8px 12px;
      border-radius: 8px;
      transition: all 0.2s;
      
      &:hover {
        background: #f0f5ff;
      }
    }
    
    .ant-tree-title {
      a {
        color: #434343;
        text-decoration: none;
        display: block;
        padding: 4px 0;
        
        &:hover {
          color: #1677ff;
        }
      }
    }
  }
`;

export const MobileContentCard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  min-height: calc(100vh - ${NAVBAR_HEIGHT} - 120px);
  
  @media (min-width: ${BREAKPOINTS.md}px) and (max-width: ${BREAKPOINTS.xl - 1}px) {
    padding: 24px 32px;
  }
`;

export const FooterText = styled.div`
  text-align: center;
  padding: 24px 16px;
  font-size: ${FONT_SIZE.xs};
  color: rgba(0, 0, 0, 0.45);
  
  @media (max-width: ${BREAKPOINTS.md}px) {
    padding: 16px;
    font-size: 12px;
  }
`;